module.exports = __webpack_public_path__ + "static/commit-right-86dbf0168813e331f3d2e1fd3f5eec36.png";